import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BitfPaginatorComponent } from '../bitf-paginator.component';

@Component({
  selector: 'bitf-mat-paginator',
  templateUrl: './bitf-mat-paginator.component.html',
  styleUrls: ['./bitf-mat-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BitfMatPaginatorComponent extends BitfPaginatorComponent {
  @Input() showFirstLastButtons: boolean;

  onMatPagechange(event: PageEvent) {
    this.pagination.page = event.pageIndex + this.pageIndexOffset;
    this.pagination.size = event.pageSize;
    this.onPageChange(this.pagination);
  }
}
